import { Divider } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import dataAtIds from '../../dataAtIds.json';
import AppInfo from './AppInfo';
import Page from '../Page/Page';
import PageBody from '../Page/PageBody';
import PageHeader from '../Page/PageHeader';
import PageTitle from '../Page/PageTitle';
import SDKConfig from './SDKConfig';

const Settings: FunctionComponent = () => {
  return (
    <Page backgroundColor="white" data-trace-at-id={dataAtIds.SettingsPage} paddingVertical="x8">
      <PageHeader maxWidth="60rem">
        <PageTitle>Settings</PageTitle>
      </PageHeader>

      <PageBody backgroundColor="white" maxWidth="60rem">
        <AppInfo />
        <Divider color="gray-3" margin="x10" width="1px" />
        <SDKConfig />
      </PageBody>
    </Page>
  );
};

export default Settings;
